import Icon from '@components/atoms/icon/icon';
import styles from './VariationIcon.module.scss';

type VariationIconProps = typeof Icon;

export const VariationIcon: VariationIconProps = ({ name }) => {
  return (
    <Icon
      className={styles.icon}
      name={`${name}-default`}
      ariaHidden
    />
  );
};
